export const ProhibitedNotice = ({href}) =>
  <div className='text-center pb-6'>
    <h4 className='mb-3'>{I18n.t('donate.prohibited_headline')}</h4>
    <div className='mb-6'>{I18n.t('donate.prohibited_notice')}</div>
    <a className='btn btn-primary btn-large' href={href}>{I18n.t('donate.prohibited_call_to_action')}</a>
  </div>
